import { useEffect, useState } from 'react';
import { NET_VERDICT, getNetworkVerdict, subscribeNetworkVerdict } from '../lib/offline/networkVerdict';

/**
 * useNetworkStatus — el hook ÚNICO de estado de red (F6.7b, fase 2).
 *
 * Todas las superficies del censo (a) consumen ESTO en vez de deducir la
 * conectividad de su propio fetch. Resultado: el chip de offline y los
 * controles que dependen de la red se prenden y se apagan solos, en cualquier
 * pantalla, sin navegar.
 *
 * Devuelve:
 *   - verdict: 'unknown' | 'up' | 'down' (el dictamen del vigía)
 *   - isOffline: SOLO true con un `offline` recibido. UNKNOWN no es offline.
 *   - isOnline:  SOLO true con un `online` recibido. UNKNOWN no es online.
 *   - hasVerdict: ¿ya llegó algún evento?
 *
 * La asimetría es a propósito: sin dictamen la app se comporta EXACTAMENTE
 * como hoy — ninguna pantalla inventa un estado de red que nadie le dijo.
 */
export function useNetworkStatus() {
  const [verdict, setVerdict] = useState(getNetworkVerdict);

  useEffect(() => {
    // Re-lectura al montar: entre el render inicial y este efecto pudo llegar
    // un evento (el módulo escucha desde que se carga, no desde que montamos).
    setVerdict(getNetworkVerdict());
    return subscribeNetworkVerdict(setVerdict);
  }, []);

  return {
    verdict,
    isOffline: verdict === NET_VERDICT.DOWN,
    isOnline: verdict === NET_VERDICT.UP,
    hasVerdict: verdict !== NET_VERDICT.UNKNOWN,
  };
}

export default useNetworkStatus;
